// extracted by mini-css-extract-plugin
module.exports = {"dd-empty":"EmptyListImageComponent-module__dd-empty__3BzgI"};